module.exports = __webpack_public_path__ + "files/46661d6d65debc63884004fed6e37e5c.svg";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/exo2-bolditalic-webfont.svg
// module id = 670
// module chunks = 60